import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ModalAssociarCardComponent } from './modal-associar-card/modal-associar-card.component';
import { NbDialogService, COSMIC_THEME } from '@nebular/theme';
import { Router } from '@angular/router';

@Component({
  selector: 'ngx-vincular-card',
  templateUrl: './vincular-card.component.html',
  styleUrls: ['./vincular-card.component.scss']
})
export class VincularCardComponent implements OnInit {

  public formCard = null;
  public rowData = null;

  constructor(
    private formBuilder: FormBuilder,
    private dialogService: NbDialogService,
    private router: Router,
  ) {

    this.formCard = this.formBuilder.group({
      cpf: [null],
      matricula: [null],
    });
  }

  buscarHistLimite(data) {


    this.rowData = [
      {
        matricula: "04",
        cpf: "05159527613",
        nome: "Welton Luiz de Almeida Brito",
      },
      {
        matricula: "04",
        cpf: "05159527613",
        nome: "Welton Luiz de Almeida Brito",
      },
    ];



  }

  showCardModal(data: any) {

    this.dialogService.open(ModalAssociarCardComponent, {
      context: {
        nome: data.nome,
        cpf: data.cpf,
        matricula: data.matricula,
      },
    });

  }

  ngOnInit() {
  }

  previousPage() {
    this.router.navigate(['/iot-dashboard']);
  }

}
